/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type GetCardAccountsResponseDataItemCardsItemCardImageDetailsOneOfCardOrientation = typeof GetCardAccountsResponseDataItemCardsItemCardImageDetailsOneOfCardOrientation[keyof typeof GetCardAccountsResponseDataItemCardsItemCardImageDetailsOneOfCardOrientation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCardAccountsResponseDataItemCardsItemCardImageDetailsOneOfCardOrientation = {
  LANDSCAPE: 'LANDSCAPE',
  PORTRAIT: 'PORTRAIT',
} as const;
